import React from "react";
import { Link } from "gatsby";
import { Layout } from "../components/Layout";
import { Heading, Text, Flex, Button } from "@chakra-ui/react";

const ThankYouPage = () => (
  <Layout>
    <Flex direction="column" align="center" justify="center" py={20} px={4} mb={4}>
      <Heading size="lg" px={10} pt={10} textAlign="center">
        Thank you for reaching out to us!
      </Heading>
      <Text>
        We appreciate your interest in Canyou and will get back to you as soon
        as possible. In the meantime, feel free to explore our website and learn
        more about how Canyou can help your business streamline training,
        compliance, and operations tasks.
      </Text>
      <Button mt={6} width="190px" as={Link} to="/">
        Back to Home
      </Button>
    </Flex>
  </Layout>
);

export default ThankYouPage;
